import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';

const TYPE = 'text/csv';
const EXTENSION = '.csv';

@Injectable()
export class CsvService {
  constructor() {
  }

  public exportAsCSVFile(json: any[], fileName: string, headings: string[], headerLabel: string[]): void {

    const array = typeof json != 'object' ? JSON.parse(json) : json;
    let str = '';
    let row = '';

    const newHeaders = headerLabel;

    for (const index in newHeaders) {
      row += newHeaders[index] + ';';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (const index in headings) {
        const head = headings[index];
        if (line.length > 0) {
          line += ';';
        }
        // 0 and false are values, only null/undefined stay empty
        if (array[i][head] !== null && array[i][head] !== undefined) {
          line += this.strRep(array[i][head]);
        }
      }
      str += line + '\r\n';
    }


    this.saveAsCSVFile(['\ufeff' + str], fileName);
  }

  private strRep(data: any) {
    if (typeof data == 'string') {
      // ";" separates columns, line breaks separate rows
      const newData = data.replace(/[;\r\n]+/g, ' ');
      if (newData == 'null') {
        return '';
      }
      return newData;
    } else if (typeof data == 'undefined') {
      return '';
    } else if (typeof data == 'number') {
      return data.toString();
    } else {
      return data;
    }
  }

  private saveAsCSVFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: TYPE});
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXTENSION);
  }

}
